export default "__VITE_ASSET__DR0lT2Rd__"